import {
  SET_ACTION_CONFIRMATION_CANCEL,
  SET_ACTION_CONFIRMATION_DIALOG,
  SET_ACTION_CONFIRMATION_FUNCTION,
  SET_CANCEL_CONFIRMATION_DIALOG,
  SET_GLOBAL_ERROR,
  SET_GLOBAL_ERROR_MESSAGE,
  SET_GLOBAL_LOADING,
  SET_GLOBAL_SUCCESS,
  SET_GLOBAL_SUCCESS_MESSAGE,
  SET_SIDEBAR_OPEN,
} from "../actionTypes/globalActionType";

const initialState = {
  isSuccess: false,
  successMessage: "",
  isError: false,
  errorMessage: "",
  loading: false,
  actionDialogOpen: false,
  actionDialogFunction: null,
  actionDialogCancel: null,
  cancelDialogOpen: false,
  sidebarOpen: false,
};

export const globalReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_GLOBAL_LOADING:
      return { ...state, loading: payload };

    case SET_GLOBAL_SUCCESS:
      return { ...state, isSuccess: payload };

    case SET_GLOBAL_SUCCESS_MESSAGE:
      return { ...state, successMessage: payload };

    case SET_GLOBAL_ERROR:
      return { ...state, isError: payload };

    case SET_GLOBAL_ERROR_MESSAGE:
      return { ...state, errorMessage: payload };

    case SET_ACTION_CONFIRMATION_DIALOG:
      return { ...state, actionDialogOpen: payload };

    case SET_ACTION_CONFIRMATION_FUNCTION:
      return { ...state, actionDialogFunction: payload };

    case SET_ACTION_CONFIRMATION_CANCEL:
      return { ...state, actionDialogCancel: payload };

    case SET_CANCEL_CONFIRMATION_DIALOG:
      return { ...state, cancelDialogOpen: payload };

    case SET_SIDEBAR_OPEN:
      return { ...state, sidebarOpen: payload };

    default:
      return state;
  }
};
